import {
  Box,
  Icon,
  LinearProgress,
  Link,
  Modal,
  Tooltip,
  Snackbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import CloseIcon from "@mui/icons-material/Close";
import ComingSoonModal from "./Modal/ComingSoonModal";
import FindDivineModal from "./Modal/FindDivineModal";
import MembershipModal from "./Modal/MembershipModal";
import Image from "next/image";
import NewBlockHeader from "./NewBlockHeader/NewBlockHeader";
import { useDispatch } from "react-redux";
import { getCookie } from "./utils/cookie";
import { updateProductCount } from "../redux/fetcher/TarrotCardSlice";
import InfoIcon from "@mui/icons-material/Info";
const Footer = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [newOpen, setNewOpen] = useState(false);

  const handleNewOpen = () => setNewOpen(true);
  const handleNewClose = () => setNewOpen(false);

  const [newwOpen, setNewwOpen] = useState(false); //-------diviner state----------//

  // << ------------ Floating Button --------------- >>

  const [showButton, setShowButton] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState(false);
  const [snackMsg, setSnackMsg] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const specificDiv = document.getElementById("wrpper_of_cards");
      if (specificDiv) {
        const rect = specificDiv.getBoundingClientRect();
        // Check if the specific div is in the viewport
        if (rect.top <= window.innerHeight && rect.bottom >= 0) {
          setShowButton(true);
        } else {
          setShowButton(false);
        }
      }
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);
    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // << ------------ Floating Button --------------- >>

  const dispatch = useDispatch();

  // const productQuantity = async (type, itemID) => {
  //   let updatedQuantity = quantity;

  //   if (type == "add") {
  //     updatedQuantity = quantity + 1;
  //     setQuantity(updatedQuantity);
  //   }

  //   await addToCart(false, updatedQuantity, itemID);
  // };
  const productQuantity = async (type, itemID, redirectPath = null) => {
    let updatedQuantity = quantity;

    if (type == "add") {
      updatedQuantity = quantity + 1;
      setQuantity(updatedQuantity);
    }

    await addToCart(false, updatedQuantity, itemID, redirectPath);
  };

  useEffect(() => {
    async function fetchData() {
      let obj = {
        searchcondition: {
          user_id: getCookie("guest_id"),
        },
        sort: {
          type: "asc",
          field: "priority",
        },
      };

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...obj }),
      };

      let rep = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/cart-user-list`,
        requestOptions
      );
      rep = await rep.json();
      console.log("rep============>", rep);

      if (rep.status === "success") {
        const count = rep.results.res?.reduce(
          (accumulator, currentValue) => accumulator + currentValue.quantity,
          0
        );
        localStorage.setItem("cartCount", parseInt(count));
      }
    }

    fetchData();
  }, []);
  // const addToCart = async (isBuyNow, updatedQuantity, itemID) => {
  //   setLoaderOpen(true);

  //   let payload = {
  //     product_id: itemID,
  //     quantity: updatedQuantity,
  //     user_id: getCookie("user_id")
  //       ? getCookie("user_id")
  //       : getCookie("guest_id"),
  //     fromCartpage: true,
  //   };

  //   const requestOptions = {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(payload),
  //   };

  //   let resp = await fetch(
  //     `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/add-update-cart`,
  //     requestOptions
  //   );

  //   resp = await resp.json();

  //   console.log("resp===========", resp);

  //   if (resp && resp.status == "success") {
  //     setSnackbarState(true);
  //     setSnackMsg("Product Added to Cart");

  //     let obj = {
  //       searchcondition: {
  //         user_id: getCookie("user_id")
  //           ? getCookie("user_id")
  //           : getCookie("guest_id"),
  //       },
  //       sort: {
  //         type: "asc",
  //         field: "priority",
  //       },
  //     };

  //     const requestOptions = {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ ...obj }),
  //     };
  //     let rep = await fetch(
  //       `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/cart-user-list`,
  //       requestOptions
  //     );
  //     rep = await rep.json();
  //     console.log("rep============>", rep);
  //     if (rep.status == "success") {
  //       const count = rep.results.res?.reduce(
  //         (accumulator, currentValue) => accumulator + currentValue.quantity,
  //         0
  //       );
  //       localStorage.setItem("cartCount", parseInt(count));
  //       dispatch(updateProductCount(parseInt(count)));
  //     }
  //     setLoaderOpen(false);
  //   } else {
  //     if (resp.message == "Out of Stock") {
  //       setSnackbarState(true);
  //       setSnackMsg("Out of Stock");
  //       setLoaderOpen(false);
  //     } else {
  //       setSnackbarState(true);
  //       setSnackMsg("Something went wrong !!");
  //       setLoaderOpen(false);
  //     }
  //   }
  // };
  const addToCart = async (
    isBuyNow,
    updatedQuantity,
    itemID,
    redirectPath = null
  ) => {
    setLoaderOpen(true);

    let payload = {
      product_id: itemID,
      quantity: updatedQuantity,
      user_id: getCookie("guest_id"),
      fromCartpage: true,
    };

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    };

    let resp = await fetch(
      `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/add-update-cart`,
      requestOptions
    );

    resp = await resp.json();

    console.log("resp===========", resp);

    if (resp && resp.status == "success") {
      setSnackbarState(true);
      setSnackMsg("Product Added to Cart");

      let obj = {
        searchcondition: {
          user_id: getCookie("guest_id"),
        },
        sort: {
          type: "asc",
          field: "priority",
        },
      };

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...obj }),
      };
      let rep = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/cart-user-list`,
        requestOptions
      );
      rep = await rep.json();
      console.log("rep============>", rep);
      if (rep.status == "success") {
        const count = rep.results.res?.reduce(
          (accumulator, currentValue) => accumulator + currentValue.quantity,
          0
        );
        localStorage.setItem("cartCount", parseInt(count));
        dispatch(updateProductCount(parseInt(count)));
      }

      if (redirectPath) {
        router.push(redirectPath);
        setLoaderOpen(false);
      } else {
        setLoaderOpen(true);
      }
    } else {
      if (resp.message == "Out of Stock") {
        setSnackbarState(true);
        setSnackMsg("Out of Stock");
        setLoaderOpen(false);
      } else {
        setSnackbarState(true);
        setSnackMsg("Something went wrong !!");
        setLoaderOpen(false);
      }
    }
  };
  const handleNewwOpen = () => {
    setNewwOpen(true);
  };

  const [membershipOpen, setMembershipOpen] = useState(false);

  const memberfunc = () => {
    setMembershipOpen(true);
  };
  const router = useRouter();
  const location = useRouter();
  const { pathname } = location;

  const currentYear = new Date().getFullYear();

  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // =================copyright modal===============
  const [copyRightOpen, setCopyRightOpen] = useState(false);
  const copyRightMOdal = () => {
    setCopyRightOpen(true);
  };

  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:900px)");

  let logoBanner = "/image/logobanner_desktop.webp";

  if (isMobile) {
    logoBanner = "/image/logobanner.webp";
  } else if (isTablet) {
    logoBanner = "/image/logobanner.webp";
  }

  const [showOtherBlocks, setShowOtherBlocks] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOtherBlocks(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const excludedPaths = [
    "/perennial-signup",
    "/perennial-mandalism",
    "/astrology-community",
  ];

  return (
    <>
      {!pathname.includes("central-doctrine") &&
        !excludedPaths.includes(pathname) && (
          <div className="top_footer_main">
            {/* <div className="subTop_Footer">
          <div className="block_footer">
            <span>"Become a Professional Divination Consultant,</span>
            <span><span onClick={() => router.push('/tarot-astrology-certification ')}>CLICK</span> to see our 24 week courses!"</span>
          </div>
        </div> */}
            <NewBlockHeader />
          </div>
        )}
      <div className="homebottombanner">
        <div className="asmainwrapper">
          <div className="homebottombannerleft">
            <span className="bannerLogo bannerLogoafter">
              <span className="logoviewlink" onClick={handleOpen}>
                <Image
                  src="/image/viewicon.webp"
                  alt="View Icon"
                  width={200}
                  height={100}
                  style={{ width: "100%", height: "auto" }}
                  priority={false}
                />
              </span>
              <Image
                src="/image/logobanner_cropped.webp"
                alt="Footer Logo"
                width={400}
                height={100}
                style={{ width: "100%", height: "auto" }}
                priority={false}
              />
            </span>
            <p data-text="SCHOOL OF OUR DIVINE"> SCHOOL OF OUR DIVINE </p>
            <p data-text="infinite being"> infinite being </p>
            <article>
              Polytheistic Monism - Divine Theurgy - Oracle to the Gods
            </article>
            <div className="homebottombannerleftbottombg"></div>
          </div>
          <div className="homebottombannerright">
            <div className="homebottombannerrightinner">
              <p>
                {" "}
                “Ineffable, hidden, brilliant scion, whose motion is whirring,
                you scattered the dark mist that lay before your eyes and,
                flapping your wings, you whirled about, and through this world,
                you brought pure light.”{" "}
              </p>
              <label>Ancient Orphic Hymn</label>
            </div>
          </div>
        </div>
      </div>

      <div className="footer_section footer_section_new">
        <div className="footer_content">
          <div className="countDiv">
            <div className="asmainwrapper">
              <div className="navfooter">
                <div className="footerleft">
                  <ul className="nav_ul">
                    <li className={`mainmenu`}>
                      <Link
                        href="/"
                        type="button"
                        className={`${
                          pathname && pathname == "/" ? "active2" : ""
                        }`}
                        onClick={() => router.push("/")}
                      >
                        Home
                      </Link>
                    </li>
                    <li className={`mainmenu`}>
                      <Link
                        href="/tarot-astrology-certification"
                        type="button"
                        className={`${
                          pathname &&
                          pathname == "/tarot-astrology-certification"
                            ? "active2"
                            : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          router.push("/tarot-astrology-certification");
                        }}
                      >
                        Divination Certification
                      </Link>
                    </li>
                    {/* <li className={`mainmenu`} onClick={handleClose}><span className="link" onClick={handleNewwOpen}>Divination Services</span></li> */}
                  </ul>
                  <ul className="nav_ul">
                    <li className="mainmenu">
                      <span className={`submenuhead link `}>
                        Mystery School
                      </span>
                      <div className="sub_nav sub_nav1">
                        <ul className="submenu homesubmenu">
                          <li>
                            <Link
                              href="/central-doctrine"
                              type="button"
                              className={` ${
                                pathname && pathname == "/central-doctrine"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/central-doctrine")}
                            >
                              {" "}
                              Central Doctrine
                            </Link>
                          </li>
                          <li>
                            <Link
                              href="/layman-explanation"
                              type="button"
                              className={` ${
                                pathname && pathname == "/layman-explanation"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/layman-explanation")}
                            >
                              {" "}
                              Layman Explanation
                            </Link>
                          </li>
                          <li>
                            <Link
                              href="/divine-arcana-tarot"
                              type="button"
                              className={` ${
                                pathname && pathname == "/divine-arcana-tarot"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() =>
                                router.push("/divine-arcana-tarot")
                              }
                            >
                              {" "}
                              Divine Arcana Tarot{" "}
                            </Link>
                          </li>
                          <li>
                            <Link
                              href="/rota-the-wheel"
                              type="button"
                              className={` ${
                                pathname && pathname == "/rota-the-wheel"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/rota-the-wheel")}
                            >
                              {" "}
                              ROTA the Wheel
                            </Link>
                          </li>
                          <li onClick={() => handleNewOpen()}>
                            <span className="link">
                              {" "}
                              Suggested Order of Practice
                            </span>
                            {/* <Link
                              // href="/inner-mysteries-and-astrology"
                              type="button"
                              className={` ${
                                pathname &&
                                pathname == "/inner-mysteries-and-astrology"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => handleNewOpen()}
                            >
                              {" "}
                              Inner Mysteries and Astrology
                            </Link> */}
                          </li>
                          <li>
                            <Link
                              href="/raja-kundalini"
                              type="button"
                              className={` ${
                                pathname && pathname == "/raja-kundalini"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/raja-kundalini")}
                            >
                              {" "}
                              Raja Kundalini
                            </Link>
                          </li>
                        </ul>
                        <ul className="submenu homesubmenu">
                          <li onClick={() => handleNewOpen()}>
                            <span className="link"> Planetary Meditation</span>
                            {/* <Link
                              // href="/inner-mysteries-and-astrology"
                              type="button"
                              className={` ${
                                pathname &&
                                pathname == "/inner-mysteries-and-astrology"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => handleNewOpen()}
                            >
                              {" "}
                              Inner Mysteries and Astrology
                            </Link> */}
                          </li>

                          <li onClick={() => handleNewOpen()}>
                            <span className="link">
                              {" "}
                              Inner Mysteries and Astrology
                            </span>
                            {/* <Link
                              // href="/inner-mysteries-and-astrology"
                              type="button"
                              className={` ${
                                pathname &&
                                pathname == "/inner-mysteries-and-astrology"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => handleNewOpen()}
                            >
                              {" "}
                              Inner Mysteries and Astrology
                            </Link> */}
                          </li>
                          <li>
                            <Link
                              href="/astrological-theurgy"
                              type="button"
                              className={` ${
                                pathname && pathname == "/astrological-theurgy"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() =>
                                router.push("/astrological-theurgy")
                              }
                            >
                              {" "}
                              Iamblichean vs. Astrological Theurgy
                            </Link>
                          </li>
                          <li>
                            <Link
                              href="/ritual-praxis"
                              type="button"
                              className={` ${
                                pathname && pathname == "/ritual-praxis"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/ritual-praxis")}
                            >
                              {" "}
                              Theurgic Ritual Praxis
                            </Link>
                          </li>
                        </ul>
                        <ul className="submenu homesubmenu">
                          <li>
                            {/* <span className="link"> Ontology of Being</span> */}
                            <Link
                              href="/ontology-of-being"
                              type="button"
                              className={` ${
                                pathname && pathname == "/ontology-of-being"
                                  ? "active2"
                                  : ""
                              }`}
                              // onClick={() => handleNewOpen()}
                              onClick={() => router.push("/ontology-of-being")}
                            >
                              {" "}
                              Ontology of Being
                            </Link>
                          </li>
                          <li>
                            {/* <span className="link"> Deities</span> */}
                            <Link
                              href="/deities"
                              type="button"
                              className={` ${
                                pathname && pathname == "/deities"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/deities")}
                            >
                              {" "}
                              Deities
                            </Link>
                          </li>
                          {/* <li>
                              }`}
                              onClick={() => handleNewOpen()}
                            >
                              {" "}
                              Ontology of Being
                            </Link>
                          </li>
                        </ul>
                        <ul className="submenu homesubmenu">
                          {/* <li>
                            <Link
                              href="/pentagram-ritual"
                              type="button"
                              className={` ${
                                pathname && pathname == "/pentagram-ritual"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/pentagram-ritual")}
                            >
                              {" "}
                              Pentagram Ritual
                            </Link>
                          </li>
                          <li>
                            <Link
                              href="/ochema-ritual'"
                              type="button"
                              className={` ${
                                pathname && pathname == "/ochema-ritual"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/ochema-ritual")}
                            >
                              Ochêma Ritual
                            </Link>
                          </li> */}
                          <li>
                            <Link
                              href="/influences"
                              type="button"
                              className={` ${
                                pathname && pathname == "/influences"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/influences")}
                            >
                              Influences
                            </Link>
                          </li>

                          <li>
                            <Link
                              href="/tarot-typology"
                              type="button"
                              className={` ${
                                pathname && pathname == "/tarot-typology"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/tarot-typology")}
                            >
                              Tarot Typology
                            </Link>
                          </li>
                          <li>
                            <Link
                              href="/calendar-of-events"
                              type="button"
                              className={` ${
                                pathname && pathname == "/calendar-of-events"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/calendar-of-events")}
                            >
                              Calendar of Events
                            </Link>
                          </li>
                          {/* <li onClick={handleClose}>
                            <span className="link" onClick={() => memberfunc()}>Membership</span></li>
                          <li ><Link href="/influences" type="button" className={` ${(pathname && pathname == '/influences') ? 'active2' : ''}`} onClick={() => router.push('/influences')}>Influences</Link></li> */}
                        </ul>
                      </div>
                    </li>
                  </ul>

                  {/* <ul className="nav_ul">
                    <li className="mainmenu">
                      <span className={`submenuhead  link`}>Essays</span>
                      <div className="sub_nav ">
                        <ul className="submenu homesubmenu">
                          <li>
                            <Link
                              href="/chaldean-mysteries"
                              type="button"
                              className={` ${
                                pathname && pathname == "/chaldean-mysteries"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/chaldean-mysteries")}
                            >
                              {" "}
                              Chaldean Mysteries
                            </Link>
                          </li>
                          <li>
                            <Link
                              href="/alexandria"
                              type="button"
                              className={` ${
                                pathname && pathname == "/alexandria"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/alexandria")}
                            >
                              {" "}
                              Alexandria{" "}
                            </Link>
                          </li>
                          <li>
                            <Link
                              href="/aleister-crowley"
                              type="button"
                              className={` ${
                                pathname && pathname == "/aleister-crowley"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/aleister-crowley")}
                            >
                              Aleister Crowley
                            </Link>
                          </li>
                          <li>
                            <Link
                              href="/joseph-smith"
                              type="button"
                              className={` ${
                                pathname && pathname == "/joseph-smith"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() => router.push("/joseph-smith")}
                            >
                              Joseph Smith
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul> */}

                  {/* <ul className="nav_ul">
                    <li className={`mainmenu`}>
                      <Link
                        href="/our-faculty"
                        type="button"
                        className={`${
                          pathname && pathname == "/our-faculty"
                            ? "active2"
                            : ""
                        }`}
                        onClick={() => router.push("/our-faculty")}
                      >
                        {" "}
                        Our Faculty
                      </Link>
                    </li>
                    <li className={`mainmenu`}>
                      <Link
                        href="/psi-studies"
                        type="button"
                        className={`${
                          pathname && pathname == "/psi-studies"
                            ? "active2"
                            : ""
                        }`}
                        onClick={() => router.push("/psi-studies")}
                      >
                        {" "}
                        PSI Studies +
                      </Link>
                    </li>
                    
                  </ul> */}

                  <ul className="nav_ul">
                    <li className="mainmenu">
                      <span className={`submenuhead  link`}>
                        Perennial Mandalism
                      </span>
                      <div className="sub_nav ">
                        <ul className="submenu homesubmenu">
                          <li>
                            {/* <span className="link"> Astrology Community</span> */}
                            <Link
                              href="/astrology-community"
                              type="button"
                              className={` ${
                                pathname && pathname == "/astrology-community"
                                  ? "active2"
                                  : ""
                              }`}
                              // onClick={() => handleNewOpen()}
                              onClick={() =>
                                router.push("/astrology-community")
                              }
                            >
                              {" "}
                              Astrology Community
                            </Link>
                          </li>
                          <li>
                            <Link
                              href="/perennial-mandalism"
                              type="button"
                              className={` ${
                                pathname && pathname == "/perennial-mandalism"
                                  ? "active2"
                                  : ""
                              }`}
                              onClick={() =>
                                router.push("/perennial-mandalism")
                              }
                            >
                              {" "}
                              Five Fold Creed{" "}
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>

                  <ul className="nav_ul">
                    <li className={`mainmenu`}>
                      <Link
                        href="/shop"
                        type="button"
                        className={`${
                          pathname && pathname == "/shop" ? "active2" : ""
                        }`}
                        onClick={() => router.push("/shop")}
                      >
                        {" "}
                        Shop
                      </Link>
                    </li>
                    <li className={`mainmenu`}>
                      <Link
                        href="/curl-jung-debates"
                        type="button"
                        className={`${
                          pathname && pathname == "/curl-jung-debates"
                            ? "active2"
                            : ""
                        }`}
                        onClick={() => router.push("/curl-jung-debates")}
                      >
                        {" "}
                        Jung Debates
                      </Link>
                    </li>
                    <li className={`mainmenu`}>
                      <Link
                        href="/contact-us"
                        type="button"
                        className={`${
                          pathname && pathname == "/contact-us" ? "active2" : ""
                        }`}
                        onClick={() => router.push("/contact-us")}
                      >
                        {" "}
                        contact
                      </Link>
                    </li>
                    <li className={`mainmenu`}>
                      <Link
                        type="button"
                        // href="https://divineinfinitebeing.influxiq.com/"
                        href={process.env.NEXT_PUBLIC_BACKOFFICE_URL}
                      >
                        School Login
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="footerright">
                  <span className="bannerLogo bannerLogoafter">
                    <Image
                      src="/image/logobanner_cropped_footer2.webp"
                      alt="Footer Logo"
                      width={400}
                      height={100}
                      style={{ width: "100%", height: "auto" }}
                      priority={false}
                    />
                  </span>
                  <b className="h2class" data-text="SCHOOL OF OUR DIVINE">
                    {" "}
                    SCHOOL OF OUR DIVINE{" "}
                  </b>
                  <b className="h2class" data-text="infinite being">
                    {" "}
                    infinite being{" "}
                  </b>
                  <i>
                    Polytheistic Monism - Divine Theurgy - Oracle to the Gods
                  </i>
                </div>
              </div>
            </div>
          </div>
          <div className="col4 copyrights_block">
            <p className="copyright">
              © {currentYear}{" "}
              <span>School Of Our Divine Infinite Being - </span> All Rights
              Reserved{" "}
              <span
                className="privacyTermsCond"
                onClick={() => router.push("/privacypolicy")}
              >
                Privacy Policy{" "}
              </span>
              <span
                className="privacyTermsCond"
                onClick={() => router.push("/termsandconditions")}
              >
                {" "}
                Terms & Conditions
              </span>
            </p>
          </div>
        </div>
      </div>

      {showOtherBlocks && (
        <>
          <Modal
            open={newOpen}
            onClose={handleNewClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="banner_modal_main"
          >
            <Box className="banner_modal_box_new">
              <Typography
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className="modal_banner_new"
                component="div"
              >
                <div className="sub_modal_banner">
                  <span className="close_btn" onClick={handleNewClose}>
                    <CloseIcon />
                  </span>
                  <Image
                    src="/image/logobanner_cropped.webp"
                    alt="Banner Logo"
                    width={400}
                    height={100}
                    style={{ width: "100%", height: "auto" }}
                    priority={false}
                  />
                  <p className="modal_commingsoon">Coming soon</p>
                </div>
              </Typography>
            </Box>
          </Modal>

          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="banner_modal_main"
          >
            <Box className="banner_modal_box">
              <Typography
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className="modal_banner"
                component="div"
              >
                <div className="sub_modal_banner">
                  <span className="close_btn" onClick={handleClose}>
                    <CloseIcon />
                  </span>
                  <Image
                    src={logoBanner}
                    alt="Footer Logo"
                    width={400}
                    height={100}
                    style={{ width: "100%", height: "100%" }}
                    priority={false}
                  />
                </div>
              </Typography>
            </Box>
          </Modal>

          {/* -----------------------------scroll bar-------------------- */}
          <div className="top-to-btm">
            {showButton && (
              <div
                className="floatingButton"
                onClick={() =>
                  productQuantity(
                    "add",
                    `${process.env.NEXT_PUBLIC_TARROT_BOX_ID}`,
                    "/shop/cart"
                  )
                }
              >
                <span>🛒</span> Pre-Order Now
                <Tooltip title="This is a pre-order. All orders will begin shipping on November 1st.">
                  <InfoIcon
                    style={{
                      marginLeft: "8px",
                      fontSize: "26px",
                      verticalAlign: "middle",
                    }}
                  />
                </Tooltip>
              </div>
            )}{" "}
            {showTopBtn && (
              <span className="icon-position icon-style" onClick={goToTop}>
                <KeyboardDoubleArrowUpIcon />
              </span>
            )}{" "}
          </div>
          {/* ----------------------------copyright modal---------------------- */}
          {copyRightOpen ? (
            <ComingSoonModal
              copyRightOpen={copyRightOpen}
              setCopyRightOpen={setCopyRightOpen}
            />
          ) : (
            ""
          )}

          {membershipOpen ? (
            <MembershipModal
              membershipOpen={membershipOpen}
              setMembershipOpen={setMembershipOpen}
            />
          ) : (
            ""
          )}

          {newwOpen && (
            <FindDivineModal newwOpen={newwOpen} setNewwOpen={setNewwOpen} />
          )}

          <Modal
            open={loaderOpen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box className="linear_loader_modalbox">
              <LinearProgress />
            </Box>
          </Modal>

          <Snackbar
            open={snackbarState}
            autoHideDuration={3000}
            onClose={() => setSnackbarState(false)}
            className="snackbarClass"
            message={snackMsg}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            bodyStyle={{ backgroundColor: "teal", color: "coral" }}
          />
        </>
      )}
    </>
  );
};

export default Footer;
